import DefaultAttr from './default'
export default class Diagram extends DefaultAttr {
  diagramParams = {
    // 主表id/归档表id
    mainTableId: '',
    // 图表类型
    reportType: '2',
    // 维度
    dimensionality: [],
    // 指标
    norm: {},
    // 定时
    timing: '',
    // 系统默认筛选方式默认(默认普通的方式)
    systemFilterSwitch: false,
    // 筛选表达式
    filterExpression: '',
    // 统计时间
    statisticsTime: '',
    // 统计时间字段名字
    statisticsMap: '',
    // 自定义时间
    customTime: '',
    // 过去几天
    passDate: '',
    // 统计范围
    statisticsScope: '',
    // 统计值
    statisticsModel: {},
    // 求和
    statisticsType: 'COUNT',
    statisticsTitle: ''
  }
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
    // 挂载背景颜色
    this.setStyleSetting(args.type, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/diagram.js